import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  isIncomming?: boolean
}

export default createStyles((theme, { isIncomming }: StylesParams) => {
  return {
    root: {
      display: 'flex',
      gap: rem(8),
      alignItems: 'flex-start',
      ...(!isIncomming && {
        borderBottomRightRadius: 0,
        alignSelf: 'flex-end',
      }),
      [theme.fn.largerThan('sm')]: {
        maxWidth: isIncomming ? 'calc(100% - 40px)' : 'calc(100% - 80px)',
      },
      '.content': {
        borderRadius: rem(16),
        backgroundColor: isIncomming ? '#fff' : '#FBE6E6',
        padding: `${rem(8)} ${rem(12)}`,
        textAlign: 'left',
        '&:is(button)': {
          cursor: 'pointer',
        },
        ...(isIncomming
          ? {
              borderTopLeftRadius: 0,
            }
          : {
              borderBottomRightRadius: 0,
            }),
      },
    },
    avatar: {
      flexShrink: 0,
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
    },
  }
})
